import {useEffect} from 'react';
import type {ReactNode} from 'react';
import {useLocation} from 'react-router-dom';

import type {Surface} from '../surface';
import {handOffTo, handoffUrl} from './handoff';

export const IdentityRedirect = ({
  origins,
  path,
  fallback,
}: {
  origins?: Partial<Record<Surface, string>>;
  path: '/login' | '/signup';
  fallback: ReactNode;
}) => {
  const location = useLocation();
  const url = handoffUrl(origins, 'identity', `${path}${location.search}`);

  useEffect(() => {
    if (url) {
      handOffTo(url);
    }
  }, [url]);

  return url ? null : <>{fallback}</>;
};
